/**
 * Copyright © Veeam Software Group GmbH.
 */

import { LicenseUnitsTypes } from '@veeam-vspc/models/web-controllers';

import { core } from 'core/core-module';
import { transformBaseChartData } from 'views/pages/TrendsPage/helpers';

import type { BaseDataResponse } from 'core/services/transport/interfaces/base-data-response';
import type { LineChartData, TrendData } from '../../../../../interfaces';

const names = [
    { label: 'Points', type: LicenseUnitsTypes.Points },
];

export class ConsumedPointsService {
    static fetchData({ objectsType, reportingPeriodInfo }): Promise<LineChartData> {
        return core.transportService
            .request('Trends/ConsumedPoints', {
                ...reportingPeriodInfo,
                productType: objectsType,
            })
            .then((resp: BaseDataResponse<TrendData>) => transformBaseChartData(resp.data.trends, reportingPeriodInfo, names));
    }
}
